<template>
<div class="pdf-content">
  <div class="pdf-content__logo">
    <logo-svg />
  </div>
  <div class="pdf-content__results">
    <result-model
        :title="null"
        :text="sharePersonalPDF.text"
        :link="sharePersonalPDF.link"
    />
  </div>
</div>
</template>

<script>
import resultModel from './resultModel.vue';
import LogoSvg from '../../../../../assets/img/icons/logo.svg';

export default {
  name: "pdfContent",
  components: {
    resultModel,
    LogoSvg,
  },
  computed: {
    sharePersonalPDF() {
      return this.$store.state.siteData.sharePersonalPDF;
    },
  },
}
</script>

<style lang="scss">
  @import '../../../sass/setup.scss';

  .pdf-content {
    padding-top: 83px;
    width: 100%;
    height: 100%;
    background-color: $c-light-gray;

    &__logo {
      margin: 0 auto 83px;
      width: 200px;
      height: 60px;
    }

    .result-model {
      &__wrapper {
        padding-top: 0;
        display: grid;
        grid-template-columns: 100%;
      }

      &__heading,
      &__text,
      &__content {
        grid-column: 1/2;
      }

      &__text {
        grid-row: 2/3;
      }

      &__content {
        grid-row: 1/2;
        grid-template-columns: 100%;
      }

      &__preview {
        margin-bottom: 53px;
        grid-row: 2/3;
      }

      &__results {
        grid-row: 1/2;

        .results {
          //&::after {
          //  background-color: $c-light-gray;
          //}

          &__item {
            padding: 8.5px 20px 6.5px;
            grid-template-columns: auto 1fr;

            .name {
              text-align: right;
            }
          }
        }
      }
    }
  }
</style>
